import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { Root } from "./components/Root";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { store } from "./redux/Store";
import { Provider } from "react-redux";
import { ToastMessage } from "./components/shared/ToastMessage";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiModal: {
      defaultProps: {
        disableEnforceFocus: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableEnforceFocus: true,
      },
    },
  },
});

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Root />
          </BrowserRouter>
          <ToastMessage />
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
